import { articleComments } from '@/mocks/article';

export default function CommentsSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-500 tracking-wide">漫友评论</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            看看其他漫友怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleComments.map((comment, idx) => (
            <div
              key={comment.id}
              className={`bg-white rounded-lg p-5 md:p-6 ${idx >= 4 ? 'opacity-70' : ''}`}
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-secondary-300'}`}
                  ></i>
                ))}
              </div>
              <h4 className="font-semibold text-foreground-950 text-sm mb-2">{comment.title}</h4>
              <p className="text-foreground-500 text-xs leading-relaxed mb-4">{comment.content}</p>
              <div className="flex items-center gap-3">
                <img
                  src={comment.userAvatar}
                  alt={comment.userName}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-foreground-950 text-sm font-semibold">{comment.userName}</p>
                  <p className="text-foreground-500 text-xs">{comment.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}